export const LIVEKIT_URL = process.env.REACT_APP_LIVEKIT_URL || '';

export async function fetchToken({ roomName, identity, name, role }) {
  const res = await fetch('/api/livekit-token', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ roomName, identity, name, role }),
  });
  if (!res.ok) {
    let detail = res.statusText;
    try {
      const body = await res.json();
      if (body && body.error) detail = body.error;
    } catch (_) {}
    throw new Error(detail);
  }
  return res.json();
}
